export default {"src":"/_next/static/media/floorplan.d9d7f652.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};